import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface ParkingState {
  totalRecords: number | null;
  data: [] | null;
  totalPages: number | null;
  currentPage: number | null;
}

const initialState: ParkingState = {
  totalRecords: null,
  data: null,
  totalPages: null,
  currentPage: null,
};

export const parkingTimeSlice = createSlice({
  name: 'parkingTime',
  initialState,
  reducers: {
    setParkingTime: (state, action) => {
      state.data = action.payload.data;
      state.currentPage = action.payload.currentPage;
      state.totalPages = action.payload.totalPages;
      state.totalRecords = action.payload.totalRecords;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setParkingTime, reset } = parkingTimeSlice.actions;

// selectors
export const getParkingTime = (state: RootState) => state.parkings.data;

export default parkingTimeSlice.reducer;
